.outer {
    width: 100%;
    display: flex;
    justify-content: center;
}

.inner {
    max-width: 640px;
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 16px;
}